import { TextField, Typography } from '@mui/material';
import { FC } from 'react';

import Form, { Props as FormProps } from './Form';

import UploadToStorage from '../UploadToStorage';
import ImgUpload from '../ImgUpload';
import ImgGrid from '../ImgGrid';
import YesNo from '../YesNo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export interface Props extends Omit<FormProps, 'componentMap'> {}

/**
 * MyCustomForm
 * @deprecated
 */
const MyCustomForm: FC<Props> = ({ ...props }) => {
  return <Form {...props} componentMap={COMPONENT_MAP} />;
};

const COMPONENT_MAP = {
  'text-field': TextField,
  'text-input': TextField,
  'date-input': (props) => (
    <DatePicker
      {...props}
      disableFuture
      onChange={(date) => {
        const value = date || '';
        const event = { target: { value, name: props.name } };
        props.onChange(event);
      }}
      sx={{
        '&& .Mui-error .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.23)' },
        '&&& .Mui-error.MuiInputLabel-root': { color: 'unset' },
      }}
    />
  ),
  'yes/no': YesNo,
  'image-upload': UploadToStorage,
  img: ImgUpload,
  imgGrid: ImgGrid,
  text: Typography,
  default: Typography,
};
export default MyCustomForm;
